import React from 'react'

import Section from 'component/Section'
import SectionHeader from 'component/SectionHeader'
import SectionSplit from 'component/SectionSplit'
import SectionSplitWrapper from 'component/SectionSplitWrapper'
import ProductFeatures from 'component/ProductFeatures'
import { StaticImage } from 'gatsby-plugin-image'
import { StaticImageContainer } from 'component/StaticImageContainer'

import IconCalendar from 'svg/icons/calendar.svg'
import IconFolderCheck from 'svg/icons/folder-check.svg'
import LogoThemisHorizontal from 'svg/logos/themis-horizontal.svg'
import IconEye from 'svg/icons/eye.svg'
import IconFolderTransfer from 'svg/icons/folder-transfer.svg'

const ThemisSection = () => {
	return (
		<Section theme="themis">
			<SectionHeader
				titleIcon={
					<h2>
						<LogoThemisHorizontal />
					</h2>
				}
				subTitle="O melhor software jurídico para departamentos e grandes bancas"
			/>
			<SectionSplitWrapper>
				<SectionSplit size={'40'}>
					<ProductFeatures
						id={'themis'}
						imgsrc={'/a'}
						imgalt={'a'}
						buttons={[
							{
								id: 'themis-dj',
								text: 'Conheça o Themis para departamentos jurídicos',
								link: '/themis-para-departamento-juridico/',
							},
							{
								id: 'themis-ea',
								text: 'Conheça o Themis para grandes bancas',
								link: '/themis-para-escritorios-de-advocacia/',
							},
						]}
						list={[
							{
								id: '1',
								icon: <IconFolderCheck />,
								title: 'Indicadores de prevenção, provisão e produtividade!',
								description: `O Themis é o software jurídico que permite que você provisione os custos dos processos e determine os orçamentos com precisão. Assim, sua atuação jurídica fica muito mais estratégica! `,
							},
							{
								id: '2',
								icon: <IconFolderTransfer />,
								title: (
									<>
										Integração com&nbsp;
										<br className="mobile" />
										outras áreas da empresa
									</>
								),
								description: `O Themis facilita a troca de informações e a prestação de contas para outros setores. Além disso, o workflow de aprovação de valores do software oferece um ambiente ideal para diminuir os ruídos da sua comunicação e facilitar os processos de compra e aquisição.`,
							},
							{
								id: '3',
								icon: <IconEye />,
								title: (
									<>
										Total controle&nbsp;
										<br className="mobile" />
										da atuação da sua equipe
									</>
								),
								description: `O Themis oferece todas as funcionalidades para que você controle o fluxo de trabalho da sua equipe, gerencie correspondentes e tenha uma atuação focada em resultados.`,
							},
							{
								id: '4',
								icon: <IconCalendar />,
								title: (
									<>
										Prazos vinculados&nbsp;
										<br className="mobile" />
										aos processos e casos
									</>
								),
								description: `Com o serviço de publicações do Themis, você recebe as atualizações dos diários oficiais de forma automática. Já o serviço de alertas garante que você não perca nenhum prazo.`,
							},
						]}
					/>
				</SectionSplit>
				<SectionSplit size={'60'} className="desktop">
					<StaticImageContainer isOverflowVisible={true}>
						<StaticImage
							src="../../../media-library/illustrations/themis-control-panel-2.png"
							alt="Painel de controle do Themis para Escritórios de Advocacia"
							placeholder="blurred"
							width={945}
							height={559}
							formats={['AUTO', 'WEBP', 'AVIF']}
						/>
					</StaticImageContainer>
				</SectionSplit>
			</SectionSplitWrapper>
		</Section>
	)
}

export default ThemisSection
